import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUserVerifyBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m19.944 16.886-.204-.204c-.204-.204-.204-.306-.204-.612v-.408a.914.914 0 0 0-.919-.919h-.409c-.203 0-.407-.102-.611-.204l-.205-.204c-.305-.306-.918-.306-1.223 0l-.206.204c-.203.204-.305.204-.611.204h-.409a.914.914 0 0 0-.918.919v.408c0 .204-.101.408-.203.612l-.204.204c-.308.306-.308.918 0 1.224l.204.205c.204.204.204.306.204.612v.408c0 .51.408.918.918.918h.407c.204 0 .408.102.612.204l.206.204c.305.307.918.307 1.223 0l.204-.204c.204-.204.306-.204.613-.204h.409c.51 0 .918-.408.918-.918v-.408c0-.204.101-.408.203-.612l.204-.205c.306-.306.306-.816 0-1.224m-1.735.408-1.53 1.429c-.102.102-.204.204-.409.204-.203 0-.306-.102-.409-.204l-.713-.715c-.204-.204-.204-.612 0-.816s.611-.204.816 0l.306.306 1.02-1.02c.204-.204.613-.204.817 0s.306.51.102.816M15.964 7.803c.102-2.653-2.04-4.694-4.694-4.694a4.68 4.68 0 0 0-4.694 4.694 4.68 4.68 0 0 0 4.694 4.694 4.68 4.68 0 0 0 4.694-4.694"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.25 14.54c-1.43 0-2.755.203-3.775.51-.613.203-1.225.51-1.633.918a2.46 2.46 0 0 0-.714 1.734c0 .714.204 1.225.714 1.735.408.408 1.02.714 1.633.918 1.02.306 2.346.51 3.775.51.612 0 1.02-.408 1.02-1.02V15.56c0-.612-.408-1.02-1.02-1.02"
      clipRule="evenodd"
      opacity={0.4}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUserVerifyBulk);
export default ForwardRef;
